/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppReleaseControllerCreateRequest { 
    platform: AppReleaseControllerCreateRequest.PlatformEnum;
    version: string;
    isMandatory?: boolean;
    storeUrl?: string | null;
    notes?: string | null;
    /**
     * true = ya publicada. false/omitido = queda en revisión.
     */
    publish?: boolean;
}
export namespace AppReleaseControllerCreateRequest {
    export type PlatformEnum = 'web' | 'ios' | 'android';
    export const PlatformEnum = {
        Web: 'web' as PlatformEnum,
        Ios: 'ios' as PlatformEnum,
        Android: 'android' as PlatformEnum
    };
}


